module.exports = __webpack_public_path__ + "static/media/amusement(9).e2829953.PNG";